<template>
    <div class="system-dict">
        <div class="dict-tree-wrapper">
            <div class="dict-tree-title">
        <span class="title-wrapper">
          <span class="icon"></span>
          <span class="text">字典管理</span>
        </span>
                <span>
          <el-button
              type="primary"
              size="mini"
              v-if="isShowByPermission('/wyms/sysDic/addOrUpdateDicType')"
              @click="handleDicTypeAdd"
          >新增类型</el-button>
        </span>
            </div>
            <el-tree
                node-key="id"
                :data="treeList"
                :highlight-current="true"
                :default-expanded-keys="defaultExpandedKeys"
                :default-checked-keys="defaultCheckedKeys"
                :props="defaultProps"
                @node-click="handleNodeClick"
            >
        <span
            class="custom-tree-node"
            :class="{
              'first-node': node.level == 1
          }"
            slot-scope="{ node, data }"
        >
          <span class="text-wrapper">
            <i
                class="el-icon-folder-opened"
                style="margin-right: 7px;font-size: 18px;"
                v-if="node.level == 1 && node.expanded"
            ></i>
            <i
                class="el-icon-folder"
                style="margin-right: 7px;font-size: 18px;"
                v-if="node.level == 1 && !node.expanded"
            ></i>
            <span
                class="text"
                :title="data.name"
            >
              {{ data.name }}
            </span>
          </span>
          <span class="custom-tree-handle-wrapper">
            <i
                class="el-icon-plus"
                style="color: #409EFF;margin-right: 7px;"
                v-if="(node.level == 1) && isShowByPermission('/wyms/sysDic/addOrUpdateDicType')"
                @click.stop="handleAdd(node, data)"
            ></i>
            <i
                class="el-icon-edit"
                style="color: #409EFF;margin-right: 7px;"
                v-if="isShowByPermission('/wyms/sysDic/addOrUpdateDicType')"
                @click.stop="handleEdit(node, data)"
            ></i>
            <i
                class="el-icon-delete"
                style="color: #F56C6C;"
                v-if="isShowByPermission('/wyms/sysDic/deleteDicType')"
                @click.stop="handleDelete(node, data)"
            ></i>
          </span>
        </span>
            </el-tree>

            <!-- 新增或编辑字典类型 start -->
            <el-dialog
                title="添加字典类型"
                :visible.sync="dicTypeDialogVisible"
                width="40%"
                @closed="cancelDicType"
            >
                <el-form
                    label-width="80px"
                    ref="dicTypeForm"
                    :model="dicTypeForm"
                    :rules="dicTypeRules"
                >
                    <el-form-item
                        label="英文名称"
                        prop="code"
                    >
                        <el-input
                            maxlength="30"
                            placeholder="唯一，添加后不可修改"
                            :disabled="dicTypeFormType == 'edit'"
                            v-model="dicTypeForm.code"
                            @change="checkEnglish(dicTypeForm)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="中文名称"
                        prop="name"
                    >
                        <el-input
                            maxlength="20"
                            placeholder="中文名称"
                            v-model="dicTypeForm.name"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="字典描述"
                        prop="remark"
                    >
                        <el-input
                            type="textarea"
                            maxlength="250"
                            show-word-limit
                            :rows="5"
                            v-model="dicTypeForm.remark"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <span
                    slot="footer"
                    class="dialog-footer"
                >
          <el-button @click="dicTypeDialogVisible = false">取 消</el-button>
          <el-button
              type="primary"
              @click="submitDicTypeForm"
          >确 定</el-button>
        </span>
            </el-dialog>
            <!-- 新增或编辑字典类型 end -->
            <!-- 新增或编辑二级字典类型 start -->
            <el-dialog
                title="添加字典"
                :visible.sync="twoDicTypeDialogVisible"
                width="40%"
                @closed="cancelTwoDicType"
            >
                <el-form
                    label-width="80px"
                    ref="twoDicTypeForm"
                    :model="twoDicTypeForm"
                    :rules="twoDicTypeRules"
                >
                    <el-form-item
                        label="英文名称"
                        prop="code"
                    >
                        <el-input
                            maxlength="30"
                            placeholder="唯一，添加后不可修改"
                            :disabled="twoDicTypeFormType == 'edit'"
                            v-model="twoDicTypeForm.code"
                            @change="checkEnglish(twoDicTypeForm)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="中文名称"
                        prop="name"
                    >
                        <el-input
                            maxlength="20"
                            placeholder="中文名称"
                            v-model="twoDicTypeForm.name"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="公开字典"
                        prop="isOpen"
                    >
                        <el-checkbox
                            :true-label="1"
                            :false-label="0"
                            v-model="twoDicTypeForm.isOpen"
                        ></el-checkbox>
                    </el-form-item>
                    <el-form-item
                        label="字典描述"
                        prop="remark"
                    >
                        <el-input
                            type="textarea"
                            maxlength="250"
                            show-word-limit
                            :rows="5"
                            v-model="twoDicTypeForm.remark"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <span
                    slot="footer"
                    class="dialog-footer"
                >
          <el-button @click="twoDicTypeDialogVisible = false">取 消</el-button>
          <el-button
              type="primary"
              @click="submitTwoDicTypeForm"
          >确 定</el-button>
        </span>
            </el-dialog>
            <!-- 新增或编辑二级字典类型 end -->
        </div>
        <div
            class="dict-content-wrapper"
            v-show="showTable"
        >
            <el-row style="padding-bottom:12px">
                <el-col :span="24">
                    <el-button
                        type="primary"
                        size="medium"
                        v-if="isShowByPermission('/wyms/sysDic/addOrUpdateDicValue')"
                        @click="handleDicValueAdd"
                    >新增
                    </el-button>

                    <!-- <el-upload
                      style="display: inline-block"
                      name='csv_file'
                      accept=".csv, .xlsx, .xls"
                      :action="uploadPath"
                      :data="uploadData"
                      :show-file-list='false'
                      :before-upload="beforeAvatarUpload"
                      :on-success="handleAvatarSuccess"
                      v-if="isShowByPermission('/wyms/sysDic/uploadZ')"
                    >
                      <el-button
                        type="primary"
                        size="medium"
                      >导入</el-button>
                    </el-upload> -->
                    <import-student @handleSuccess="handleSuccess" ref='importSt' :keyCode="editCode"
                                    v-if="isShowByPermission('/wyms/sysDic/uploadZ')"></import-student>
                    <a target="_blank" :href="exportUrl" download="疫情区">
                        <el-button type="primary" size="medium">下载模板</el-button>
                    </a>
                    <el-button
                        type="primary"
                        size="medium"
                        @click="clearAll()"
                    >清空</el-button>
                </el-col>
            </el-row>

            <!-- 字典值表格 start -->
            <div class="table-wrapper">
                <el-table
                    stripe
                    border
                    fit
                    highlight-current-row
                    style="width: 100%"
                    :height="windowHeight - 215"
                    :data="tabList"
                >
                    <el-table-column
                        label="字典编码"
                        align="center"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.code}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="字典值"
                        align="center"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.value}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="排序号"
                        align="center"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.sort}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                      label="系统字典"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{scope.row.isSystem | filterIsSystem}}</span>
                      </template>
                    </el-table-column> -->
                    <el-table-column
                        label="描述"
                        align="center"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.remark}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <el-button
                                size="small"
                                type="text"
                                v-if="isShowByPermission('/wyms/sysDic/addOrUpdateDicValue')"
                                @click="handleDicValueEdit(scope.row)"
                            >编辑
                            </el-button>
                            <el-button
                                stlye="color: #f56c6c;"
                                size="small"
                                type="text"
                                v-if="isShowByPermission('/wyms/sysDic/deleteDicValue')"
                                @click="handleDicValueDelete(scope.row)"
                            >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                    style="margin-top: 20px"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page.sync="pagination.pageNo"
                    :page-size="pagination.pageSize"
                    :page-sizes="pagination.pageSizes"
                    :total="pagination.total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
            <!-- 字典值表格 end -->

        </div>
        <!-- 字典值新增&编辑 start -->
        <div
            class="form-wrapper"
            v-show="!showTable"
        >
            <el-row style="padding-bottom:12px; border-bottom: 1px solid #e4e7ed;">
                <el-col :span="24">
                    <el-button
                        @click="gotoTable"
                        size="medium"
                    >返回
                    </el-button>
                    <el-button
                        type="primary"
                        size="medium"
                        @click="submitDicValueForm"
                    >保存
                    </el-button>
                </el-col>
            </el-row>

            <div class="form-title">新建字典</div>

            <el-form
                label-width="150px"
                ref="dicValueForm"
                :model="dicValueForm"
                :rules="dicValueRules"
            >
                <el-form-item
                    label="字典编码"
                    prop="code"
                >
                    <el-input
                        placeholder="1-50个字符"
                        maxlength="50"
                        show-word-limit
                        v-model="dicValueForm.code"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="字典值"
                    prop="value"
                >
                    <el-input
                        placeholder="1-100个字符"
                        maxlength="100"
                        show-word-limit
                        v-model="dicValueForm.value"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="排序号"
                    prop="sort"
                >
                    <el-input-number
                        label="排序号"
                        :min="0"
                        :max="9999"
                        v-model="dicValueForm.sort"
                    ></el-input-number>
                </el-form-item>
                <el-form-item
                    label="字典描述"
                    prop="remark"
                >
                    <el-input
                        type="textarea"
                        maxlength="250"
                        show-word-limit
                        :rows="5"
                        v-model="dicValueForm.remark"
                    ></el-input>
                </el-form-item>

            </el-form>
        </div>
        <!-- 字典值新增&编辑 end -->
    </div>
</template>

<script>
    /* utils */
    import mixin from "@/mixins/windowResize";
    import {isShowByPermission} from "@/utils/utils";

    /* components */
    import importStudent from './importStudent.vue'
    /* api */
    import {
        loadDicType,
        listValue,
        getDicTypeDetail,
        addOrUpdateDicType,
        deleteDicType,
        addOrUpdateTwoDictype,
        getTwoDicTypeDetail,
        deleteTwoDictype,
        addOrUpdateDicValue,
        deleteDicValue,
        clearAllValue
    } from "@/api/systemDict";
    // 通用
    const prefix =
        global.command === "production"
            ? "https://wyms.weixiaojia.cn/wyms"
            : "http://wyms.weixiaojia.net/wyms";

    export default {
        name: "systemDict",
        mixins: [mixin],
        components: {importStudent},
        filters: {
            filterIsSystem(val) {
                return val == 0 ? "否" : "是";
            },
        },
        data() {
            return {
                editCode: '',
                exportUrl: '',
                isInit: true,
                treeList: [],
                defaultExpandedKeys: [],
                defaultCheckedKeys: [],
                defaultProps: {
                    children: "children",
                    label: "name",
                },

                /* ↓↓↓ 新增或编辑字典类型 start */
                dicTypeDialogVisible: false,
                dicTypeFormType: "add",
                dicTypeFormMessage: "新增字典类型成功",
                dicTypeForm: {
                    id: "",
                    code: "",
                    name: "",
                    remark: "",
                },
                dicTypeRules: {
                    code: [
                        {
                            required: true,
                            message: "请输入英文名称",
                            trigger: "blur",
                        },
                    ],
                    name: [
                        {
                            required: true,
                            message: "请输入中文名称",
                            trigger: "blur",
                        },
                    ],
                },
                // 用于重置表单
                defaultDicTypeForm: {
                    id: "",
                    code: "",
                    name: "",
                    remark: "",
                },
                /* ↑↑↑ 新增或编辑字典类型 end */

                /* ↓↓↓ 新增或编辑二级字典类型 start */
                twoDicTypeDialogVisible: false,
                twoDicTypeFormType: "add",
                twoDicTypeFormMessage: "新增成功",
                twoDicTypeForm: {
                    id: "",
                    code: "",
                    name: "",
                    isOpen: 0,
                    remark: "",
                    typeCode: "",
                },
                twoDicTypeRules: {
                    code: [
                        {
                            required: true,
                            message: "请输入英文名称",
                            trigger: "blur",
                        },
                    ],
                    name: [
                        {
                            required: true,
                            message: "请输入中文名称",
                            trigger: "blur",
                        },
                    ],
                },
                // 用于重置表单
                defaultTwoDicTypeForm: {
                    id: "",
                    code: "",
                    name: "",
                    isOpen: 0,
                    remark: "",
                    typeCode: "",
                },
                /* ↑↑↑ 新增或编辑二级字典类型 end */

                /* ↓↓↓ 新增或编辑字典值 start */
                showTable: true,
                dicValueFormType: "add",
                dicValueFormMessage: "保存成功",
                dicValueForm: {
                    id: "",
                    dictionaryCode: "",
                    code: "",
                    value: "",
                    sort: 0,
                    remark: "",
                },
                dicValueRules: {
                    code: [
                        {
                            required: true,
                            message: "请输入字典编码",
                            trigger: "blur",
                        },
                    ],
                    value: [
                        {
                            required: true,
                            message: "请输入字典值",
                            trigger: "blur",
                        },
                    ],
                    sort: [
                        {
                            type: "number",
                            required: true,
                            message: "请输入排序号",
                            trigger: "blur",
                        },
                    ],
                },
                // 用于重置表单
                defaultDicValueFrom: {
                    id: "",
                    dictionaryCode: "",
                    code: "",
                    value: "",
                    sort: 0,
                    remark: "",
                },
                /* ↑↑↑ 新增或编辑字典值 end */

                // 表格数据 { Array }
                tabList: [],
                // 分页
                pagination: {
                    pageNo: 1,
                    pageSize: 20,
                    pageSizes: [10, 20, 30, 50],
                    total: 0,
                },
                form: {
                    key: "",
                },

                uploadPath: prefix + "/sysDic/upload",
                uploadData: {
                    token: this.$store.getters.token,
                    key: "import-test",
                },
            };
        },

        created() {
            this.loadDicType();
            this.exportUrl = 'https://cdnfile-10043692.file.myqcloud.com/admin/xls/sysdic.csv'
        },
        methods: {
            isShowByPermission,
            // api - 字典类型和二级类型树结构
            clearAll() {
                this.$confirm("是否清空该字典", "清空", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    clearAllValue({
                        key: this.form.key
                    })
                        .then(data => {
                            this.$message.success('清空成功');
                            this.listValue();
                        })
                });
            },
            loadDicType() {
                loadDicType().then((data) => {
                    if (data) {
                        let {clickNum, treeList} = data;
                        let temp = [];
                        treeList.forEach((item) => {
                            if (item.pId == 0) {
                                temp.push({
                                    ...item,
                                    children: [],
                                });
                            } else {
                                temp.forEach((parentNode) => {
                                    if (parentNode.id == item.pId) {
                                        parentNode.children.push({
                                            ...item,
                                        });
                                    }
                                });
                            }
                        });
                        let firstHasChildrenNode = temp.find((item) => {
                            if (item.children && item.children.length) {
                                return true;
                            }
                        });
                        if (firstHasChildrenNode) {
                            // 给导入传code值
                            this.editCode = firstHasChildrenNode.children[0].code
                            console.log(this.editCode)
                            if (this.isInit) {
                                this.defaultExpandedKeys = [firstHasChildrenNode.id];
                                this.isInit = false;
                            }
                            this.form.key = firstHasChildrenNode.children[0].code;
                        }
                        this.treeList = temp;
                        this.listValue();
                    }
                });
            },

            // api - 字典值列表
            listValue() {
                listValue({
                    key: this.form.key,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                }).then((data) => {
                    let {dataList, pagination} = data;
                    this.tabList = [...dataList];
                    this.pagination.total = pagination.total;
                });
            },

            // api - 根据code查询字典类型详情
            getDicTypeDetail(item) {
                getDicTypeDetail({
                    code: item.code,
                }).then((data) => {
                    this.dicTypeFormType = "edit";
                    this.dicTypeFormMessage = "编辑字典类型成功";
                    this.dicTypeForm.id = data.id;
                    this.dicTypeForm.code = data.code;
                    this.dicTypeForm.name = data.name;
                    this.dicTypeForm.remark = data.remark;
                    this.dicTypeDialogVisible = true;
                });
            },

            // api - 新增或编辑字典类型
            addOrUpdateDicType(form) {
                addOrUpdateDicType(form).then((data) => {
                    this.$message({
                        message: this.dicTypeFormMessage,
                        type: "success",
                    });
                    this.dicTypeDialogVisible = false;
                    this.loadDicType();
                });
            },

            // api - 删除字典类型
            deleteDicType(form) {
                deleteDicType(form).then((data) => {
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    this.loadDicType();
                });
            },

            // api - 查询二级字典类型详情
            getTwoDicTypeDetail(item) {
                getTwoDicTypeDetail({
                    code: item.code,
                })
                    .then((data) => {
                        this.twoDicTypeFormType = "edit";
                        this.twoDicTypeFormMessage = "编辑成功";
                        this.twoDicTypeForm.id = data.id;
                        this.twoDicTypeForm.code = data.code;
                        this.twoDicTypeForm.name = data.name;
                        this.twoDicTypeForm.isOpen = data.isOpen;
                        this.twoDicTypeForm.remark = data.remark;
                        this.twoDicTypeForm.typeCode = data.typeCode;
                        this.twoDicTypeDialogVisible = true;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },

            // api - 新增或编辑二级字典类型
            addOrUpdateTwoDictype(form) {
                addOrUpdateTwoDictype(form).then((data) => {
                    this.$message({
                        message: this.twoDicTypeFormMessage,
                        type: "success",
                    });
                    this.twoDicTypeDialogVisible = false;
                    this.loadDicType();
                });
            },

            // api - 删除二级字典类型
            deleteTwoDictype(form) {
                deleteTwoDictype(form).then((data) => {
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    this.loadDicType();
                });
            },

            // 新增或编辑字典值
            addOrUpdateDicValue(form) {
                addOrUpdateDicValue(form).then((data) => {
                    this.$message({
                        message: this.dicValueFormMessage,
                        type: "success",
                    });
                    this.showTable = true;
                    this.listValue();
                    this.resetDicValueForm();
                });
            },

            // 删除字典值
            deleteDicValue(form) {
                deleteDicValue(form).then((data) => {
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    this.showTable = true;
                    this.listValue();
                });
            },

            // 分页 - pageSize 改变
            handleSizeChange(pageSize) {
                this.pagination.pageSize = pageSize;
                this.listValue();
            },
            // 分页 - currentPage 改变
            handleCurrentChange(pageNo) {
                this.pagination.pageNo = pageNo;
                this.listValue();
            },

            // 点击新增类型按钮
            handleDicTypeAdd() {
                this.dicTypeDialogVisible = true;
                this.dicTypeFormType = "add";
                this.dicTypeFormMessage = "新增字典类型成功";
            },
            // 点击取消按钮
            cancelDicType() {
                this.resetDicType();
            },
            // 关闭并重置表单
            resetDicType() {
                Object.keys(this.dicTypeForm).forEach((key) => {
                    this.dicTypeForm[key] = this.defaultDicTypeForm[key];
                });
                setTimeout(() => {
                    this.$refs["dicTypeForm"].clearValidate();
                }, 100);
            },
            // 保存字典类型
            submitDicTypeForm() {
                this.$refs["dicTypeForm"].validate((valid) => {
                    if (valid) {
                        let form = {
                            code: this.dicTypeForm.code,
                            name: this.dicTypeForm.name,
                            remark: this.dicTypeForm.remark,
                        };
                        if (this.dicTypeFormType == "add") {
                            this.addOrUpdateDicType(form);
                        } else {
                            form.id = this.dicTypeForm.id;
                            this.addOrUpdateDicType(form);
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            // 点击删除按钮
            handleDicTypeFormDelete(item) {
                this.$confirm(`您确定要删除字典类型【${item.name}】吗?`, "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false,
                })
                    .then(() => {
                        this.deleteDicType({
                            code: item.code,
                        });
                    })
                    .catch(() => {
                    });
            },

            // 点击取消按钮
            cancelTwoDicType() {
                this.resetTwoDicType();
            },
            // 关闭并重置表单
            resetTwoDicType() {
                Object.keys(this.twoDicTypeForm).forEach((key) => {
                    this.twoDicTypeForm[key] = this.defaultTwoDicTypeForm[key];
                });
                setTimeout(() => {
                    this.$refs["twoDicTypeForm"].clearValidate();
                }, 100);
            },
            // 保存二级字典类型
            submitTwoDicTypeForm() {
                this.$refs["twoDicTypeForm"].validate((valid) => {
                    if (valid) {
                        let form = {
                            code: this.twoDicTypeForm.code,
                            name: this.twoDicTypeForm.name,
                            isOpen: this.twoDicTypeForm.isOpen,
                            remark: this.twoDicTypeForm.remark,
                            typeCode: this.twoDicTypeForm.typeCode,
                        };
                        if (this.twoDicTypeFormType == "add") {
                            this.addOrUpdateTwoDictype(form);
                        } else {
                            form.id = this.twoDicTypeForm.id;
                            this.addOrUpdateTwoDictype(form);
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            // 点击字典类型删除按钮
            handleTwoDicTypeFormDelete(item) {
                this.$confirm(`您确定要删除字典类型【${item.name}】吗?`, "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false,
                })
                    .then(() => {
                        this.deleteTwoDicType({
                            code: item.code,
                        });
                    })
                    .catch(() => {
                    });
            },
            // 点击二级字典删除按钮
            handleTwoDicTypeFormDelete(item) {
                this.$confirm(`您确定要删除字典【${item.name}】吗?`, "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false,
                })
                    .then(() => {
                        this.deleteTwoDictype({
                            code: item.code,
                        });
                    })
                    .catch(() => {
                    });
            },

            handleNodeClick(data, node) {
                if (node.level != 1) {
                    this.editCode = data.code
                }
                console.log(node);
                if (node.level == 2) {
                    this.form.key = data.code;
                    this.uploadData.key = data.code;
                    this.pageNo = 1;
                    this.pageSize = 20;
                    this.listValue();
                }
            },
            handleAdd(node, data) {
                this.twoDicTypeDialogVisible = true;
                this.twoDicTypeFormType = "add";
                this.twoDicTypeFormMessage = "新增成功";
                this.twoDicTypeForm.typeCode = data.code;
            },
            handleEdit(node, data) {
                this.editCode = data.code
                console.log("edit");
                if (node.level == 1) {
                    this.getDicTypeDetail(data);
                    this.defaultExpandedKeys = [data.id];
                } else {
                    this.getTwoDicTypeDetail(data);
                    this.defaultExpandedKeys = [data.pId];
                }
            },
            handleDelete(node, data) {
                console.log("delete");
                if (node.level == 1) {
                    this.handleDicTypeFormDelete(data);
                } else {
                    this.handleTwoDicTypeFormDelete(data);
                }
            },

            // 字典值新增
            handleDicValueAdd() {
                this.showTable = false;
                this.dicValueFormType = "add";
            },
            handleDicValueEdit(item) {
                this.showTable = false;
                this.dicValueFormType = "edit";
                this.dicValueForm.id = item.id;
                this.dicValueForm.dictionaryCode = item.dictionaryCode;
                this.dicValueForm.code = item.code;
                this.dicValueForm.value = item.value;
                this.dicValueForm.sort = item.sort;
                this.dicValueForm.remark = item.remark;
            },
            submitDicValueForm() {
                this.$refs["dicValueForm"].validate((valid) => {
                    if (valid) {
                        let form = {
                            dictionaryCode: this.form.key,
                            code: this.dicValueForm.code,
                            value: this.dicValueForm.value,
                            sort: this.dicValueForm.sort,
                            remark: this.dicValueForm.remark,
                        };
                        if (this.dicValueFormType == "add") {
                            this.addOrUpdateDicValue(form);
                        } else {
                            form.id = this.dicValueForm.id;
                            this.addOrUpdateDicValue(form);
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            handleDicValueDelete(item) {
                this.$confirm(`您确定删除该条字典数据吗?`, "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false,
                })
                    .then(() => {
                        this.deleteDicValue({
                            id: item.id,
                        });
                    })
                    .catch(() => {
                    });
            },
            // 关闭并重置表单
            resetDicValueForm() {
                Object.keys(this.dicValueForm).forEach((key) => {
                    this.dicValueForm[key] = this.defaultDicValueFrom[key];
                });
                setTimeout(() => {
                    this.$refs["dicValueForm"].clearValidate();
                }, 100);
            },
            gotoTable() {
                this.showTable = true;
                this.resetDicValueForm();
            },

            // 导入成功触发
            handleSuccess() {
                this.listValue()
            },
            beforeAvatarUpload(file) {
                let suffix = file.name.split(".")[file.name.split(".").length - 1];
                console.log(suffix);
                if (suffix !== "csv" && suffix !== "xlsx" && suffix !== "xls") {
                    this.$message.error("请上传后缀为.csv, .xlsx, .xls的模版文件!");
                    return false;
                }
            },
            checkEnglish(val) {
                console.log(val);
                if (!/^\w+$/.test(val.code)) {
                    val.code = "";
                    console.log(val);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .system-dict {
        padding: 12px;
        display: flex;
        box-sizing: border-box;
        height: 100%;

        * {
            box-sizing: border-box;
        }

        .dict-tree-wrapper {
            flex: 0 0 240px;
            border-right: 1px solid #e4e7ed;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            .dict-tree-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 7px 15px;
            }

            /deep/ .el-tree-node__content {
                height: 32px;

                .custom-tree-node {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 14px;
                    padding-right: 15px;

                    .text-wrapper {
                        flex: 1;
                        display: flex;
                        align-items: center;

                        i {
                            flex: 0 0 14px;
                        }

                        .text {
                            flex: 0 0 180px;
                            width: 180px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            vertical-align: middle;
                        }
                    }

                    .custom-tree-handle-wrapper {
                        display: none;
                        font-size: 16px;
                    }

                    &:hover {
                        .text {
                            flex: 0 0 130px;
                            width: 130px;
                        }

                        &.first-node {
                            .text {
                                flex: 0 0 100px;
                                width: 100px;
                            }
                        }

                        .custom-tree-handle-wrapper {
                            display: block;
                        }
                    }
                }
            }
        }

        .dict-content-wrapper {
            flex: 1;
            height: 100%;
            padding-left: 12px;
        }

        .form-wrapper {
            flex: 1;
            height: 100%;
            padding-left: 12px;

            .form-title {
                font-size: 18px;
                font-weight: bold;
                color: #303133;
                text-align: center;
                margin: 12px;
            }

            .el-form {
                width: 810px;
                margin: 0 auto;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/systemData/systemDict/systemDict.vue